export const MultiplierValues = [1, 2, 5, 10] as const;
export type MultiplierT = typeof MultiplierValues[number]
